import { NavigationStatus } from '../loggers/PageViewLogger';
function calculateByteLength(str) {
    let strLength = str.length;
    let i = strLength;
    while (i--) {
        const code = str.charCodeAt(i);
        if (code > 0x7f && code <= 0x7ff) {
            strLength++;
        }
        else if (code > 0x7ff && code <= 0xffff) {
            strLength += 2;
        }
        if (code >= 0xdc00 && code <= 0xdfff) {
            i--;
        }
    }
    return strLength;
}
export function isSessionStorageSupported() {
    const expectedItem = {
        'UBI|CURRENT_PAGE_ID': 'playlist',
        'UBI|CURRENT_PAGE_INSTANCE_ID': 'bc33087f-b95a-4b15-bd48-0277666f303c',
        'UBI|CURRENT_ENTITY_URI': 'spotify:playlist:37i9dQZF1DX5trt9i14X7j',
        'UBI|CURRENT_NAV_ROOT': 'playlists-sidebar',
        'UBI|PENDING_NAV_ROOT': 'playlists-sidebar',
        'UBI|PENDING_INTERACTION_ID': '8dbc8e4d-b4f7-4870-ab9e-a3238307ea6d',
        'UBI|PENDING_NAV_REASON': 'user_interaction(8dbc8e4d-b4f7-4870-ab9e-a3238307ea6d)',
        'UBI|NAVIGATION_STATUS': NavigationStatus.NAVIGATION_COMPLETED,
        'UBI|PROVIDER_CURRENT_PAGE_INSTANCE_ID': 'bc33087f-b95a-4b15-bd48-0277666f303c',
    };
    const requiredStorageSize = Object.keys(expectedItem)
        .map((key) => {
        return (calculateByteLength(key) + calculateByteLength(expectedItem[key]));
    })
        .reduce((prevValue, currValue) => prevValue + currValue) * 4;
    try {
        const key = '__UBI_STORAGE_TEST__';
        const testValue = 'x'.repeat(requiredStorageSize);
        window.sessionStorage.setItem(key, testValue);
        window.sessionStorage.removeItem(key);
        return true;
    }
    catch (error) {
        return false;
    }
}
//# sourceMappingURL=utils.js.map